import React, { useState, useEffect } from 'react';
import { useAuth0 } from "../../react-auth0-wrapper";
import theme from '../../themes/theme';
import appPaths from '../../applicationPaths.json';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ListItem, Divider } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import TextField from '@material-ui/core/TextField';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';


export default function InvoiceList(props) {
    const [contentLoading, setContentLoading] = useState(true);
    const [invoiceList, setInvoiceList] = useState([]);
    const { isAuthenticated, loginWithRedirect, logout, getTokenSilently, user, loading } = useAuth0();
    const [editMode, setEditMode] = useState(false);

    const openPdf = (e, invoice) => {
        e.stopPropagation();
        window.open(invoice);

    }

    const convertTime = (time) => {
        time = time.split(':'); // convert to array

        // fetch
        var hours = Number(time[0]);
        var minutes = Number(time[1]);
        var seconds = Number(time[2]);
        
        // calculate
        var timeValue;
        
        if (hours > 0 && hours <= 12) {
          timeValue= "" + hours;
        } else if (hours > 12) {
          timeValue= "" + (hours - 12);
        } else if (hours == 0) {
          timeValue= "12";
        }
         
        timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;  // get minutes
        //timeValue += (seconds < 10) ? ":0" + seconds : ":" + seconds;  // get seconds
        timeValue += (hours >= 12) ? " PM" : " AM";  // get AM/PM

        return timeValue;
    }

    const convertDate = (date) => {
        let month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let d = new Date(date);
        let month = month_names[d.getMonth()];
        let day = date.split('/')[1];
        let year = date.split('/')[2];

        return month + ' ' + day + ', ' + year;
    }

    const saveNotes = async (id, note) => {
        try {
          const token = await getTokenSilently();
          const response = await fetch(appPaths.apiPath + "/api/saveInvoiceNotes", {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',  // sent request
              'Accept':       'application/json'   // expected data sent back
            },
            body: JSON.stringify({recordId: id, notes : note})
          });
         
        } catch (error) {
            console.error(error);
        }
      };

    const handleNoteChange = (invoice) => {
        let id = invoice.recordId;
        let note = invoice.fieldData.InvoiceNotes;

        saveNotes(id, note);
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
        }
    }

    useEffect(() => {
        const callApi = async () => {
            try {
              const token = await getTokenSilently();
              const response = await fetch(appPaths.apiPath + "/api/getJobInvoices", {
                method: 'POST',
                headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json',  // sent request
                  'Accept':       'application/json'   // expected data sent back
                },
                body: JSON.stringify({jobId: props.__ID})
              });
              const responseData = await response.json();
              if(responseData.message) {
                console.log(responseData.data);
                setInvoiceList(responseData.data);
                setContentLoading(false);
              }
              else {
                setInvoiceList([]);
                setContentLoading(false);
              }
            } catch (error) {
              console.error(error);
            }
        };

        callApi();
    }, [getTokenSilently, props.__ID]);

    const deleteInvoice = async (invoiceId) => {
      if( window.confirm('Are you sure you want to delete this invoice?') ) {
        setInvoiceList(prevState => {
          return prevState.filter(item => {
              return item.fieldData.__ID !== invoiceId;
          });
        });
        try {
          const token = await getTokenSilently();
          const response = await fetch(appPaths.apiPath + "/api/deleteInvoice", {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',  // sent request
              'Accept':       'application/json'   // expected data sent back
            },
            body: JSON.stringify({__ID: invoiceId})
          });
          const responseData = await response.json();
        } catch (error) {
          console.error(error);
        }
      }
    };

    const getSecondaryText = (invoice) => { 
      var datetime = convertDate(invoice.fieldData.Date_Invoice_ae) + ' ' + convertTime(invoice.fieldData.Date_Invoice_Time_ae);
      return (
        <>
        {datetime}
        <br />
        Click here to Edit
        </>
      );
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width:'100%'}}>
            {!contentLoading &&
            <>
                <Card style={{width:'100%', display: 'flex', textAlign: 'center', flexDirection:'column'}}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Open Invoices</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <List style={{width:'100%'}}>
                                <Divider />
                                {invoiceList.map(invoice => (
                                    <div key={invoice.fieldData.__ID}>
                                        <ListItem button disableRipple>
                                            <ListItemAvatar button onClick={() => {props.setRedirect({set: true, to: {pathname: "/job-edit-invoice", state: {__ID: props.__ID, invoiceId: invoice.fieldData.__ID}}})}}>
                                                <IconButton>
                                                <Avatar style={{backgroundColor:theme.palette.secondary.main}} alt={invoice.fieldData.Number_INV} src={invoice.fieldData.pictureOverheadMap_o != "" ? appPaths.apiPath + "/api/getFMInvoiceImage?url=" + invoice.fieldData.__ID : ""} />
                                                </IconButton>
                                            </ListItemAvatar>
                                            <ListItemText button onClick={() => {props.setRedirect({set: true, to: {pathname: "/job-edit-invoice", state: {__ID: props.__ID, invoiceId: invoice.fieldData.__ID}}})}} primary={invoice.fieldData.Number_INV } secondary={getSecondaryText(invoice)}/>
                                            <ListItemText style={{width: '65%'}}>
                                            <TextField
                                                id="invoice-notes"
                                                label="Notes"
                                                value={invoice.fieldData.InvoiceNotes}
                                                onChange={e => {
                                                    e.persist();
                                                    setInvoiceList(prevState => {
                                                        return [...prevState.map(item => {
                                                          if(item !== invoice) {
                                                            return item;
                                                          } else {
                                                            item.fieldData.InvoiceNotes = e.target.value;
                                                            return item;
                                                          }
                                                        })];
                                                    });
                                                }}
                                                onClick={(e) => {e.stopPropagation(); setEditMode(true); }}
                                                onBlur={() => {handleNoteChange(invoice); setEditMode(false);}}
                                                onKeyPress={handleKeyPress}
                                                style={{width: '100%'}}
                                                
                                            />
                                            </ListItemText>
                                            {editMode && <ListItemIcon>
                                                <IconButton label="Save" onClick={e => { e.stopPropagation(); setEditMode(false); }}>
                                                    <DoneIcon />
                                                </IconButton>
                                            </ListItemIcon>}
                                            {invoice.url && <ListItemIcon>
                                                <IconButton onClick={(e) => openPdf(e, invoice.url)}>
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            </ListItemIcon>}
                                            {<ListItemIcon>
                                                <IconButton onClick={e => deleteInvoice(invoice.fieldData.__ID)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </ListItemIcon>}


                                        </ListItem>
                                        <Divider />
                                    </div>
                                ))}
                            </List>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    
                </Card>
            </>
            }
            {contentLoading && <div style={{width:'100%', display: 'flex', textAlign: 'center', justifyContent:'center', borderRadius: '0px'}}><CircularProgress></CircularProgress></div>}

        </div>
    );

}